<template>
  <div class="maintenance-page text-[16px]">
    <div class="letter-container">
        <!-- 标题 -->
        <h1 class="letter-title">{{ t('maintenancePage.title') }}</h1>
        
        <!-- 问候语 -->
        <p class="greeting">{{ t('maintenancePage.greeting') }}</p>
        
        <!-- 维护时间信息 -->
        <div class="maintenance-schedule">
          <p class="schedule-text">
            {{ t('maintenancePage.scheduleText') }}<span class="color-[#F9FC2E] mx-[5px]">{{ formatMaintenanceTime() }}</span>{{ t('maintenancePage.scheduleTextEnd') }}
          </p>
          <p class="schedule-note">{{ t('maintenancePage.scheduleNote') }}</p>
        </div>
        
        <!-- 重要通知 -->
        <div class="important-notice">
          <!-- 维护提示 -->
          <p>{{ t('maintenancePage.importantNotice') }}</p>
          <!-- 提醒维护后进入游戏 -->
          <p>{{ t('maintenancePage.completed') }}</p>
          <!-- 感谢语 -->
          <p>{{ t('maintenancePage.thankYou') }}</p>
        </div>
      
      <!-- 底部插图区域 -->
      <div class="illustration-container">
        <!-- 这里你可以放你的图片 -->
        <img src="@/assets/404/404.png" alt="" class="maintenance-image" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useUserStore, useAppStore, useUIStore, useMessageStore } from '@/stores/index'
import request from '@/utils/request'

const userStore = useUserStore()
const router = useRouter()
// 多语言支持
const { t, locale } = useI18n()

const maintenanceInfo = ref<{startTime: number, endTime: number} | null>(null)

const formatTime = (timestamp: number) => {
  const date = new Date(timestamp)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  
  // 统一使用 YYYY/MM/DD HH:MM 格式
  return `${year}/${month}/${day} ${hours}:${minutes}`
}

const formatMaintenanceTime = () => {
  if (maintenanceInfo.value) {
    const startTime = formatTime(maintenanceInfo.value.startTime)
    const endTime = formatTime(maintenanceInfo.value.endTime)
    return `${startTime} - ${endTime}`
  }
  return t('maintenancePage.defaultTime')
}

onMounted(async () => {
  // 可以从localStorage或其他地方获取维护信息
  const info = localStorage.getItem('maintenanceInfo')
  if (info) {
    maintenanceInfo.value = JSON.parse(info)
  }
  
  // 调用新的接口
  try {
    const data = await request.get('/platform/banner/getAll')
    console.log(data, 'banner data')
    
    // 根据接口返回的数据判断是否需要跳转
    if (data.code === 0 || data.code === 200) {
      router.replace('/')
    }
  } catch (error) {
    console.error('获取banner数据失败:', error)
    // 如果接口调用失败，可以保持当前页面或做其他处理
  }
})

onUnmounted(() => {
  // 离开404页面时清除跳转标记
  sessionStorage.removeItem('maintenanceJumped')
})

// 监听页面卸载事件，确保清除标记
window.addEventListener('beforeunload', () => {
  sessionStorage.removeItem('maintenanceJumped')
})
</script>

<style scoped>
.maintenance-page {
  min-height: 100vh;
  padding: 40px 20px;
  display: flex;
  color: #ffffff;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  line-height: 1;
}

.letter-container {
  width: 100%;
  max-width: 800px;
  text-align: center;
}

.letter-title {
  margin: 0 0 40px 0;
  font-size: 2.2rem;
  font-weight: 700;
  letter-spacing: 0.5px;
  line-height: 1.3;
}

.greeting {
  margin: 0 0 30px 0;
  font-size: 1.1rem;
  font-weight: 500;
  letter-spacing: 0.3px;
  line-height: 1.7;
  text-align: left;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.maintenance-schedule {
  margin: 35px 0 15px 0;
  text-align: left;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.schedule-text {
  margin: 0 0 15px 0;
  font-size: 1.1rem;
  font-weight: 400;
  letter-spacing: 0.2px;
  line-height: 1.8;
  word-spacing: 0.5px;
}

.schedule-note {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 400;
  letter-spacing: 0.1px;
  line-height: 1.6;
  font-style: italic;
  text-indent: 1em;
}

.important-notice {
  margin:0 0 0 0;
  text-align: left;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.important-notice p {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 400;
  letter-spacing: 0.2px;
  line-height: 1.8;
  word-spacing: 0.3px;
  text-indent: 0;
}

.illustration-container {
  margin-top: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.maintenance-image {
  max-width: 80%;
  height: auto;
  border-radius: 8px;

}

/* 响应式设计 */
@media (max-width: 768px) {
  .maintenance-page {
    padding: 30px 15px;
  }
  
  .letter-title {
    font-size: 1.8rem;
    margin-bottom: 30px;
    letter-spacing: 0.3px;
  }
  
  .greeting {
    font-size: 1rem;
    margin-bottom: 25px;
    letter-spacing: 0.2px;
  }
  
  .maintenance-schedule {
    margin: 25px 0;
  }
  
  .schedule-text {
    font-size: 1rem;
    line-height: 1.7;
    letter-spacing: 0.1px;
  }
  
  .schedule-note {
    font-size: 0.9rem;
    line-height: 1.5;
  }
  
  .important-notice {
  
  }
  
  .important-notice p {
    font-size: 1rem;
    line-height: 1.7;
  }
  
  .illustration-container {
  
  }
}

@media (max-width: 480px) {
  .maintenance-page {
    padding: 20px 12px;
  }
  
  .letter-title {
    font-size: 1.6rem;
    margin-bottom: 25px;
  }
  
  .greeting {
    font-size: 0.95rem;
    margin-bottom: 20px;
  }
  
  .schedule-text {
    font-size: 0.95rem;
    line-height: 1.6;
  }
  
  .schedule-note {
    font-size: 0.85rem;
  }
  
  .important-notice p {
    font-size: 0.95rem;
    line-height: 1.6;
  }
  
  .illustration-container {
 
  }
}
</style>